import { Injectable } from "@angular/core";
import { Carousel } from "./carousel.model";
import { EntityState, ActiveState, StoreConfig } from "@datorama/akita";
import { FirebaseStore } from "../state/firebase.store";

export interface CarouselState extends EntityState<Carousel, string>, ActiveState<string> {}

@Injectable({ providedIn: "root" })
@StoreConfig({ name: "carousel" })
export class CarouselStore extends FirebaseStore<CarouselState> {
  constructor() {
    super();
  }
}
